'use client'

import React, {useEffect, useRef} from 'react'
import ImageToggle from "@/app/components/atomic/ImageToggle"
import { IAppCard } from "@/@types/AppCard"
import { useHealthComparatorStore } from "@/app/stores/health/health-comparator-store"
import { useTracking } from "@/app/contexts/tracking-context"
import { HealthTrackingEnum } from "@/app/enums/HealthTrackingEnum"
import { postValidateLanding } from "@/app/endpoints/healthComparatorEndpoints"
import Adult from "@/public/images/health/comparator/cards/adult.png";
import Couple from "@/public/images/health/comparator/cards/couple.png";
import AdultChildren from "@/public/images/health/comparator/cards/adult_children.png";
import CoupleChildren from "@/public/images/health/comparator/cards/couple_children.png";

interface SelectCardProps {
    label?: string
}

const cards: IAppCard[] = [
    {
        label: 'Un adulte',
        value: 0,
        image: Adult,
    },
    {
        label: 'Un couple',
        value: 1,
        image: Couple,
    },
    {
        label: 'Un adulte + enfant(s)',
        value: 2,
        image: AdultChildren,
    },
    {
        label: 'Un couple + enfant(s)',
        value: 3,
        image: CoupleChildren,
    },
]

export default function HealthCardChoices({
       label,
   }: SelectCardProps) {
    const { comparatorForm, originRoute } = useHealthComparatorStore()
    const { track } = useTracking()
    const profileSelectionFiredRef = useRef(false)

    const handleCardClick = (value: number) => {
        // The tokenless landing replaces the funnel's family-type step, where this event is otherwise fired.
        if (!profileSelectionFiredRef.current) {
            profileSelectionFiredRef.current = true
            track({ event: HealthTrackingEnum.ProfileSelection })
        }

        useHealthComparatorStore.setState((state) => {
            state.comparatorForm.family_type = value;
        });
    }

    useEffect(() => {
        if (comparatorForm.family_type === null) return

        const familyType = comparatorForm.family_type

        const createQuoteAndRedirect = async () => {
            const data = await postValidateLanding({
                abTestReviewsVersion: null,
                token: null,
                assignToExpert: null,
                partnerSource: null,
                originRoute,
            })
            if (data?.token) {
                window.location.href = `/devis-mutuelle-sante/${data.token}/1?familyType=${familyType}&comesFromLanding=true`
            }
        }

        createQuoteAndRedirect()
    }, [comparatorForm.family_type, originRoute]);

    return (
        <div>
            {label && (
                <label
                    htmlFor="card"
                    className="text-blue-700 text-base min-[1200px]:text-lg font-semibold mb-5 block"
                >
                    {label}
                </label>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {cards.map((card) => (
                    <ImageToggle
                        key={`card-${card.value}`}
                        dataTest={`select-card-${card.value}`}
                        image={card.image}
                        label={card.label}
                        selected={comparatorForm.family_type === card.value}
                        onClick={() => handleCardClick(card.value)}
                    />
                ))}
            </div>
        </div>
    )
}

